import { openDB } from 'idb'
import type { DraftData, TabelaOrcamento } from './types'

const DB_NAME = 'gerador-docs-db'
const STORE_NAME = 'rascunho'

async function initDB() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME)
      }
    }
  })
}

export async function salvarRascunho(data: DraftData) {
  const db = await initDB()
  await db.put(STORE_NAME, data, 'form')
}

export async function carregarRascunho(): Promise<DraftData | null> {
  const db = await initDB()
  const data = (await db.get(STORE_NAME, 'form')) as DraftData | undefined
  if (!data) return null

  if ((!data.tabelas_orcamento || data.tabelas_orcamento.length === 0) && data.orcamento?.length) {
    data.tabelas_orcamento = [
      {
        id: crypto.randomUUID(),
        nomeDespesa: data.nomeDespesa || '',
        itens: data.orcamento
      } as TabelaOrcamento
    ]
  }

  if (!data.tabelas_orcamento) {
    data.tabelas_orcamento = []
  }

  if (!('meios' in data) || !Array.isArray(data.meios)) data.meios = [];
  if (!('meiosUfc' in data) || !Array.isArray((data as any).meiosUfc)) (data as any).meiosUfc = [];
  if (typeof data.recursosFinanceiros !== 'string') data.recursosFinanceiros = '';
  if (typeof data.infraestrutura !== 'string') data.infraestrutura = '';


  return data
}

export async function limparRascunho() {
  const db = await initDB()
  await db.delete(STORE_NAME, 'form')
}